import { adminModuleQuery, useModule } from 'system/structure-modules';

export default function AdminIndexScreen() {
    const { AdminDashboard } = useModule(adminModuleQuery);
    return <AdminDashboard />;
}
